function readCookie(n: string): string | undefined | null {
  if (typeof document === 'undefined') {
    return null;
  }
  return (document.cookie.split(/;\s*/).find((c) => c.startsWith(`${n}=`)) || '').slice(n.length + 1) || undefined;
}

export default readCookie;
